import { IDetailsSidebarStoreSegment } from './detailsSidebar.interface';

export const detailsSidebarStoreSelector = (state: IDetailsSidebarStoreSegment) => {
  return state.detailsSidebar;
};
